import React from 'react';
import { Container } from 'semantic-ui-react';
import { RouteApp } from './routes';
import MainMenu from './components/MainMenu';

class Main extends React.Component {
    render() {
        return (
            <Container fluid className="app-container">
                <MainMenu />
                <RouteApp />
            </Container>
        )        
    } 
}

export default Main;